<template>
  <el-form
    ref="searchFrom"
    class="selectForm"
    :model="searchFrom"
    :inline="true"
    label-width="auto"
    @submit.native.prevent
  >
    <i @click="back" v-if="backFalg" class="el-icon-arrow-left"></i>
    <!-- v-hasPermi="[authIdentity + ':add']" -->
    <el-form-item v-show="isAdd" v-hasPermi="[authIdentity + ':add']">
      <el-button class="line-button" icon="el-icon-plus" @click="handleAdd">{{ add }}</el-button>
    </el-form-item>
    <!-- v-hasPermi="[authIdentity +  ':add']" -->
    <el-form-item v-show="isAdds" v-hasPermi="[authIdentity + ':add']">
      <el-button class="line-button" :icon="icon2" @click="handleAdds">{{ adds }}</el-button>
    </el-form-item>

    <span v-for="(item, index) in selectOrInputList" :key="index">
      <el-form-item :class="item.class ? item.class : ''">
        <template v-if="['select'].includes(item.type)">
          <el-select
            class="block"
            v-model="searchFrom[item.model]"
            filterable
            :allow-create="item.allowCreate"
            clearable
            :placeholder="item.placeholder"
            @clear="handleSearch"
            :remote="item.remote"
            :remote-method="(val)=>remoteMethod(val,item)"
          >
            <el-option
              v-for="(row) in item.list"
              :key="row[item.value]"
              :label="row[item.label]"
              :value="row[item.value]"
              @click.native="handleSearch(item.model)"
            ></el-option>
          </el-select>
        </template>
        <template v-if="['inputRange'].includes(item.type)">
          <el-input
            :disabled="item.disabled"
            v-model="searchFrom[item.model[0]]"
            :placeholder="item.placeholder[0]"
            clearable
            class="input-range"
          />
          <span class="input-range-sqe">~</span>
          <el-input
            :disabled="item.disabled"
            v-model="searchFrom[item.model[1]]"
            :placeholder="item.placeholder[1]"
            clearable
            class="input-range"
          />
        </template>
        <el-input
          :disabled="item.disabled"
          v-if="['input'].includes(item.type)"
          v-model="searchFrom[item.model]"
          :placeholder="item.placeholder"
          clearable
          @keyup.enter.native="handleSearch"
        />
        <span class="picker">
          <el-date-picker
            v-if="['year'].includes(item.type)"
            v-model="searchFrom[item.model]"
            type="year"
            value-format="yyyy"
            :placeholder="item.placeholder"
            @change="handleDateChange"
          ></el-date-picker>
        </span>
      </el-form-item>
    </span>

    <el-form-item v-if="isTime">
      <el-date-picker
        v-model="time"
        type="daterange"
        range-separator="至"
        :start-placeholder="startTimeText"
        :end-placeholder="endTimeText"
        value-format="yyyy-MM-dd"
      />
    </el-form-item>

    <el-form-item>
      <el-button class="line-button" icon="el-icon-search" @click="handleSearch" v-if="isSearch">搜索</el-button>

      <el-button class="iconfont icon-zhongzhi" @click="handelReset">重置</el-button>
      <!-- v-dynHasPermi:[authIdentity]="'import'" -->
      <el-button class="iconfont icon-daoru" @click="handleImport" plain v-show="isImport">导入</el-button>
      <el-button
        class="iconfont icon-zhongzhi"
        @click="handlePrint"
        plain
        v-show="isPrint"
        v-hasPermi="[authIdentity + ':print']"
      >打印</el-button>

      <!-- <el-button
        class="export-button"
        icon="el-icon-upload2"
        v-dynHasPermi:[authIdentity]="'export'"
        @click="handelExport"
        plain
        v-show="isExport"
      >导出</el-button>-->
      <!-- v-dynHasPermi:[authIdentity]="item.auth" -->
      <el-button
        v-for="(item, index) in opsBtnList"
        :key="index"
        :class="['batch-button', item.class, {'delete-button':item.field == 'del'}]"
        :icon="item.icon"
        @click="opsBtnClick(item.field, item)"
        plain
        :disabled="item.disable"
      >{{ item.label }}</el-button>

      <el-button v-if="synchronous" @click="synchronousfun" class="line-button">手动同步</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { addDateRange } from '@/utils/common'
export default {
  name: 'searchComponent',
  // components: { TreeSelect },
  props: {
    isDefault: {
      type: Boolean,
      default() {
        return false
      },
    },
    backFalg: {
      type: Boolean,
      default() {
        return false
      },
    },
    synchronous: {
      type: Boolean,
      default: false,
    },
    defaultSearch: {
      type: Object,
      default() {
        return {}
      },
    },
    selectOrInputList: {
      type: Array,
      default() {
        return []
      },
    },
    // // 下拉框列表
    // selectList: {
    //   type: Array,
    //   default() {
    //     return []
    //   },
    // },
    // // 输入框列表
    // inputList: {
    //   type: Array,
    //   default() {
    //     return []
    //   },
    // },
    //操作按钮列表
    opsBtnList: {
      type: Array,
      default() {
        return []
      },
    },
    isAdd: {
      type: Boolean,
      default: false,
    },
    isAdds: {
      type: Boolean,
      default: false,
    },
    startTimeText: {
      type: String,
      default: '开始日期',
    },
    endTimeText: {
      type: String,
      default: '结束日期',
    },
    add: {
      type: String,
      default: '新增',
    },
    adds: {
      type: String,
      default: '新增',
    },
    isTime: {
      type: Boolean,
      default: false,
    },
    /** */
    isSearch: {
      type: Boolean,
      default: true,
    },
    isExport: {
      type: Boolean,
      default: false,
    },
    isPrint: {
      type: Boolean,
      default: false,
    },
    batch: {
      type: Boolean,
      default: false,
    },
    isImport: {
      type: Boolean,
      default: false,
    },
    icon2: {
      type: String,
      default: 'el-icon-plus',
    },
    addsAuth: {
      type: String,
      default: 'add',
    },
    authIdentity: {
      type: String,
      required: false,
      default: 'xxx:xxx',
    },
    //TreeSelect组件属性
    normalizer: {
      type: Function,
      default: function () {},
    },
  },
  data() {
    return {
      time: '',
      searchFrom: {},
      aotoCompVal: '',
    }
  },
  computed: {},
  created() {
    if (this.isDefault) {
      this.selectOrInputList.forEach((item) => {
        Object.keys(this.defaultSearch).forEach((key) => {
          if (item.model == key) {
            this.searchFrom[item.model] = this.defaultSearch[key]
          }
        })
      })
    }
    //console.log(this.searchFrom, 'this.searchFromthis.searchFromthis.searchFrom---------------')
  },
  methods: {
    back() {
      this.$emit('back')
    },
    remoteMethod(val, item) {
      //console.log('val000000000000000000000000000000')
      this.$emit('remoteMethod', val, item)
    },
    batchApproval() {
      this.$emit('batchApproval')
    },
    synchronousfun() {
      this.$emit('synchronousfun')
    },
    handleExport() {
      // const exportList = this.list.map((data, i) => {
      //   var obj = { index2: i + 1 }
      //   this.content.forEach((d, i) => {
      //     obj[d.field] = data[d.field]
      //   })
      //   ;(obj.status =
      //     (data.status == 0 && '草稿') ||
      //     (data.status == 1 && '审批中') ||
      //     (data.status == 2 && '同意') ||
      //     (data.status == 3 && '不同意') ||
      //     (data.status == 4 && '已重新提交') ||
      //     (data.status == 5 && '再次提交')),
      //     // scope.row.laborApplyDetails[0].procName
      //     (obj.supplierName = data.laborApplyDetails
      //       ? data.laborApplyDetails[0].procName
      //       : '')
      //   // obj.signStatus = (data.signStatus == '20' && '未签订') || (data.signStatus == '21' && '签订中') || (data.signStatus == '22' && '已签订');
      //   return {
      //     ...obj,
      //   }
      // })
      // if (exportList.length == 0) {
      //   this.$message.warning('数据为空，请先搜索再导出')
      //   return
      // }
      // console.log(exportList, 'exportList')
      // var arr = [this.filename]
      // var arr2 = ['序号']
      // var arr3 = ['index2']
      // this.content.forEach((d, i) => {
      //   if (d.label !== '操作') {
      //     arr.push('')
      //     arr2.push(d.label)
      //     arr3.push(d.field)
      //   }
      // })
      // console.log(arr, arr2, arr3, 'arr3')
      // import('@/vendor/Export2Excel').then((excel) => {
      //   const multiHeader = [arr, arr2]
      //   const filterVal = arr3
      //   const data = this.formatJson(filterVal, exportList)
      //   const merges = ['A1:I1']
      //   excel.export_json_to_excel({
      //     title: [this.filename],
      //     multiHeader,
      //     data,
      //     merges,
      //     filename: this.filename,
      //   })
      // })
    },
    /** 新增 */
    handleAdd() {
      this.$emit('on-add')
    },

    /** 第二个新增 */
    handleAdds() {
      this.$emit('on-adds', this.searchFrom)
    },

    /** 下拉框 */
    handleSelect() {
      // this.$emit("handleSelect",this.searchFrom);
    },
    handleDateChange(type) {
      this.$emit('on-date', this.searchFrom, type)
      this.$forceUpdate()
    },
    /** 搜索 */
    handleSearch(type) {
      let time = addDateRange({}, this.time)
      this.searchFrom = Object.assign(this.searchFrom, time)
      this.$emit('on-search', this.searchFrom, type)
      this.$forceUpdate()
    },
    handleTreeSelect() {
      this.$nextTick(() => {
        this.handleSearch('tree')
      })
    },
    onClear() {
      //console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa')
    },
    // handleTreeBeforeClearAll() {
    //   const treeData = this.selectList.filter((item) => item.type == 'tree' && item.isClearModel == true)
    //   if (treeData.length > 0) {
    //     this.handelTreeReset(treeData[0].model)
    //     return true
    //   } else {
    //     this.handelReset()
    //     return true
    //   }
    // },
    // 导入
    handleImport() {
      this.$emit('on-import', this.searchFrom)
    },
    handlePrint() {
      this.$emit('on-print', this.searchFrom)
    },
    /** 搜索 */
    // handelExport() {
    //   this.$emit('on-export', this.searchFrom)
    // },

    /** 重置 */
    // handelTreeReset(model) {
    //   this.searchFrom[model] = ''
    //   this.time = ''
    //   this.$emit('on-reset', this.searchFrom)
    // },
    handelReset() {
      this.searchFrom = {}
      if (this.isDefault) {
        this.selectOrInputList.forEach((item) => {
          Object.keys(this.defaultSearch).forEach((key) => {
            if (item.model == key) {
              this.searchFrom[item.model] = this.defaultSearch[key]
            }
          })
        })
      }
      this.time = ''
      this.$emit('on-reset', this.searchFrom)
    },

    /** 操作按钮点击 */
    opsBtnClick(field, item) {
      this.$emit(`on-${field}`, item)
    },
  },
}
</script>

<style lang='less' scoped>
@import '~@/assets/variables.less';
.el-icon-arrow-left {
  font-size: 30px;
  margin-top: 5px;
  color: @theme-color;
  cursor: pointer;
}
.el-button {
  border-radius: @btn-radius-size;
  border-color: #b7b7b7;
}

.line-button {
  background-color: @theme-color;
  border-color: @theme-color;
  margin-left: 20 !important;
  color: #ffffff;
}

.delete-button {
  color: #ffffff !important;
  background-color: #f56c6c !important;
  border-color: #f56c6c !important;
  &:hover {
    color: #f56c6c !important;
    background-color: #ffffff !important;
  }
}

.export-button {
  border: 1px solid @theme-color;
  color: #2f4cdd;
}

.import-button {
  border: 1px solid #2f4cdd;
  color: #2f4cdd;
}

::v-deep {
  .newhome {
    .el-input {
      input {
        width: 240px !important;
      }
    }
  }
  .el-input {
    input {
      width: 100% !important;
    }
  }
}
.el-form-item {
  margin-bottom: 10px;
}

.selectForm {
  ::v-deep {
    .el-select,
    .el-input,
    .el-input__inner {
      width: 200px;
      border-radius: @btn-radius-size;
    }

    .el-date-editor {
      width: 245px;
    }

    // 阿里图标
    .iconfont::before {
      margin-right: 8px;
      color: #000;
    }
    .input-range {
      width: 120px;
    }
    .input-range-sqe {
      margin: 0 5px;
    }
  }
  ::v-deep .picker {
    .el-date-editor {
      width: 190px;
    }
  }
}
</style>
